var cov_3je0ixb3g = function () {
  var path = '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/directives/dashboard-table-activity.js',
      hash = 'ef67684f0c0d81e7adbdc329b60e8397dd45a4f8',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/opt/tomcat/.jenkins/workspace/delta-bitbucket-production/client/src/app/directives/dashboard-table-activity.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 390,
          column: 3
        }
      },
      '1': {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 389,
          column: 4
        }
      },
      '2': {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 67
        }
      },
      '3': {
        start: {
          line: 13,
          column: 19
        },
        end: {
          line: 13,
          column: 28
        }
      },
      '4': {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 31
        }
      },
      '5': {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 44
        }
      },
      '6': {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 45,
          column: 8
        }
      },
      '7': {
        start: {
          line: 17,
          column: 8
        },
        end: {
          line: 44,
          column: 9
        }
      },
      '8': {
        start: {
          line: 19,
          column: 12
        },
        end: {
          line: 19,
          column: 121
        }
      },
      '9': {
        start: {
          line: 21,
          column: 12
        },
        end: {
          line: 21,
          column: 119
        }
      },
      '10': {
        start: {
          line: 23,
          column: 12
        },
        end: {
          line: 23,
          column: 124
        }
      },
      '11': {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 122
        }
      },
      '12': {
        start: {
          line: 27,
          column: 12
        },
        end: {
          line: 27,
          column: 110
        }
      },
      '13': {
        start: {
          line: 29,
          column: 12
        },
        end: {
          line: 29,
          column: 110
        }
      },
      '14': {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 110
        }
      },
      '15': {
        start: {
          line: 33,
          column: 12
        },
        end: {
          line: 33,
          column: 110
        }
      },
      '16': {
        start: {
          line: 35,
          column: 12
        },
        end: {
          line: 35,
          column: 110
        }
      },
      '17': {
        start: {
          line: 37,
          column: 12
        },
        end: {
          line: 37,
          column: 110
        }
      },
      '18': {
        start: {
          line: 39,
          column: 12
        },
        end: {
          line: 39,
          column: 110
        }
      },
      '19': {
        start: {
          line: 41,
          column: 12
        },
        end: {
          line: 41,
          column: 110
        }
      },
      '20': {
        start: {
          line: 43,
          column: 12
        },
        end: {
          line: 43,
          column: 110
        }
      },
      '21': {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 70,
          column: 8
        }
      },
      '22': {
        start: {
          line: 48,
          column: 10
        },
        end: {
          line: 50,
          column: 11
        }
      },
      '23': {
        start: {
          line: 49,
          column: 12
        },
        end: {
          line: 49,
          column: 54
        }
      },
      '24': {
        start: {
          line: 52,
          column: 10
        },
        end: {
          line: 52,
          column: 37
        }
      },
      '25': {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 55,
          column: 11
        }
      },
      '26': {
        start: {
          line: 54,
          column: 12
        },
        end: {
          line: 54,
          column: 124
        }
      },
      '27': {
        start: {
          line: 57,
          column: 10
        },
        end: {
          line: 64,
          column: 12
        }
      },
      '28': {
        start: {
          line: 66,
          column: 10
        },
        end: {
          line: 66,
          column: 31
        }
      },
      '29': {
        start: {
          line: 68,
          column: 10
        },
        end: {
          line: 68,
          column: 34
        }
      },
      '30': {
        start: {
          line: 72,
          column: 6
        },
        end: {
          line: 78,
          column: 8
        }
      },
      '31': {
        start: {
          line: 73,
          column: 8
        },
        end: {
          line: 75,
          column: 9
        }
      },
      '32': {
        start: {
          line: 74,
          column: 10
        },
        end: {
          line: 74,
          column: 37
        }
      },
      '33': {
        start: {
          line: 77,
          column: 8
        },
        end: {
          line: 77,
          column: 36
        }
      },
      '34': {
        start: {
          line: 80,
          column: 6
        },
        end: {
          line: 86,
          column: 8
        }
      },
      '35': {
        start: {
          line: 81,
          column: 8
        },
        end: {
          line: 83,
          column: 9
        }
      },
      '36': {
        start: {
          line: 82,
          column: 10
        },
        end: {
          line: 82,
          column: 17
        }
      },
      '37': {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 30
        }
      },
      '38': {
        start: {
          line: 85,
          column: 8
        },
        end: {
          line: 85,
          column: 51
        }
      },
      '39': {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 154,
          column: 8
        }
      },
      '40': {
        start: {
          line: 90,
          column: 25
        },
        end: {
          line: 90,
          column: 29
        }
      },
      '41': {
        start: {
          line: 91,
          column: 27
        },
        end: {
          line: 91,
          column: 31
        }
      },
      '42': {
        start: {
          line: 93,
          column: 25
        },
        end: {
          line: 93,
          column: 77
        }
      },
      '43': {
        start: {
          line: 94,
          column: 38
        },
        end: {
          line: 123,
          column: 11
        }
      },
      '44': {
        start: {
          line: 124,
          column: 22
        },
        end: {
          line: 124,
          column: 23
        }
      },
      '45': {
        start: {
          line: 125,
          column: 10
        },
        end: {
          line: 130,
          column: 11
        }
      },
      '46': {
        start: {
          line: 126,
          column: 12
        },
        end: {
          line: 128,
          column: 13
        }
      },
      '47': {
        start: {
          line: 127,
          column: 14
        },
        end: {
          line: 127,
          column: 23
        }
      },
      '48': {
        start: {
          line: 129,
          column: 12
        },
        end: {
          line: 129,
          column: 77
        }
      },
      '49': {
        start: {
          line: 132,
          column: 23
        },
        end: {
          line: 132,
          column: 35
        }
      },
      '50': {
        start: {
          line: 133,
          column: 10
        },
        end: {
          line: 136,
          column: 11
        }
      },
      '51': {
        start: {
          line: 134,
          column: 12
        },
        end: {
          line: 134,
          column: 74
        }
      },
      '52': {
        start: {
          line: 135,
          column: 12
        },
        end: {
          line: 135,
          column: 49
        }
      },
      '53': {
        start: {
          line: 137,
          column: 10
        },
        end: {
          line: 137,
          column: 74
        }
      },
      '54': {
        start: {
          line: 138,
          column: 10
        },
        end: {
          line: 138,
          column: 102
        }
      },
      '55': {
        start: {
          line: 139,
          column: 10
        },
        end: {
          line: 141,
          column: 11
        }
      },
      '56': {
        start: {
          line: 140,
          column: 12
        },
        end: {
          line: 140,
          column: 66
        }
      },
      '57': {
        start: {
          line: 142,
          column: 10
        },
        end: {
          line: 142,
          column: 50
        }
      },
      '58': {
        start: {
          line: 143,
          column: 10
        },
        end: {
          line: 143,
          column: 60
        }
      },
      '59': {
        start: {
          line: 146,
          column: 25
        },
        end: {
          line: 146,
          column: 77
        }
      },
      '60': {
        start: {
          line: 148,
          column: 40
        },
        end: {
          line: 150,
          column: 11
        }
      },
      '61': {
        start: {
          line: 152,
          column: 10
        },
        end: {
          line: 152,
          column: 64
        }
      },
      '62': {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 217,
          column: 8
        }
      },
      '63': {
        start: {
          line: 157,
          column: 23
        },
        end: {
          line: 203,
          column: 9
        }
      },
      '64': {
        start: {
          line: 165,
          column: 12
        },
        end: {
          line: 167,
          column: 13
        }
      },
      '65': {
        start: {
          line: 166,
          column: 14
        },
        end: {
          line: 166,
          column: 21
        }
      },
      '66': {
        start: {
          line: 168,
          column: 12
        },
        end: {
          line: 170,
          column: 13
        }
      },
      '67': {
        start: {
          line: 169,
          column: 14
        },
        end: {
          line: 169,
          column: 21
        }
      },
      '68': {
        start: {
          line: 171,
          column: 12
        },
        end: {
          line: 173,
          column: 13
        }
      },
      '69': {
        start: {
          line: 172,
          column: 14
        },
        end: {
          line: 172,
          column: 21
        }
      },
      '70': {
        start: {
          line: 174,
          column: 12
        },
        end: {
          line: 174,
          column: 36
        }
      },
      '71': {
        start: {
          line: 175,
          column: 12
        },
        end: {
          line: 177,
          column: 15
        }
      },
      '72': {
        start: {
          line: 176,
          column: 14
        },
        end: {
          line: 176,
          column: 157
        }
      },
      '73': {
        start: {
          line: 178,
          column: 12
        },
        end: {
          line: 178,
          column: 37
        }
      },
      '74': {
        start: {
          line: 188,
          column: 12
        },
        end: {
          line: 190,
          column: 13
        }
      },
      '75': {
        start: {
          line: 189,
          column: 14
        },
        end: {
          line: 189,
          column: 34
        }
      },
      '76': {
        start: {
          line: 191,
          column: 12
        },
        end: {
          line: 193,
          column: 13
        }
      },
      '77': {
        start: {
          line: 192,
          column: 14
        },
        end: {
          line: 192,
          column: 34
        }
      },
      '78': {
        start: {
          line: 194,
          column: 12
        },
        end: {
          line: 196,
          column: 13
        }
      },
      '79': {
        start: {
          line: 195,
          column: 14
        },
        end: {
          line: 195,
          column: 36
        }
      },
      '80': {
        start: {
          line: 197,
          column: 12
        },
        end: {
          line: 199,
          column: 13
        }
      },
      '81': {
        start: {
          line: 198,
          column: 14
        },
        end: {
          line: 198,
          column: 45
        }
      },
      '82': {
        start: {
          line: 205,
          column: 8
        },
        end: {
          line: 211,
          column: 9
        }
      },
      '83': {
        start: {
          line: 206,
          column: 10
        },
        end: {
          line: 206,
          column: 42
        }
      },
      '84': {
        start: {
          line: 208,
          column: 10
        },
        end: {
          line: 208,
          column: 46
        }
      },
      '85': {
        start: {
          line: 209,
          column: 10
        },
        end: {
          line: 209,
          column: 34
        }
      },
      '86': {
        start: {
          line: 210,
          column: 10
        },
        end: {
          line: 210,
          column: 42
        }
      },
      '87': {
        start: {
          line: 213,
          column: 8
        },
        end: {
          line: 216,
          column: 16
        }
      },
      '88': {
        start: {
          line: 214,
          column: 10
        },
        end: {
          line: 214,
          column: 64
        }
      },
      '89': {
        start: {
          line: 215,
          column: 10
        },
        end: {
          line: 215,
          column: 65
        }
      },
      '90': {
        start: {
          line: 219,
          column: 6
        },
        end: {
          line: 307,
          column: 8
        }
      },
      '91': {
        start: {
          line: 220,
          column: 18
        },
        end: {
          line: 220,
          column: 46
        }
      },
      '92': {
        start: {
          line: 222,
          column: 8
        },
        end: {
          line: 306,
          column: 11
        }
      },
      '93': {
        start: {
          line: 224,
          column: 10
        },
        end: {
          line: 224,
          column: 35
        }
      },
      '94': {
        start: {
          line: 225,
          column: 18
        },
        end: {
          line: 225,
          column: 84
        }
      },
      '95': {
        start: {
          line: 226,
          column: 10
        },
        end: {
          line: 228,
          column: 11
        }
      },
      '96': {
        start: {
          line: 227,
          column: 12
        },
        end: {
          line: 227,
          column: 19
        }
      },
      '97': {
        start: {
          line: 229,
          column: 10
        },
        end: {
          line: 231,
          column: 11
        }
      },
      '98': {
        start: {
          line: 230,
          column: 12
        },
        end: {
          line: 230,
          column: 88
        }
      },
      '99': {
        start: {
          line: 232,
          column: 10
        },
        end: {
          line: 234,
          column: 11
        }
      },
      '100': {
        start: {
          line: 233,
          column: 12
        },
        end: {
          line: 233,
          column: 41
        }
      },
      '101': {
        start: {
          line: 236,
          column: 31
        },
        end: {
          line: 245,
          column: 11
        }
      },
      '102': {
        start: {
          line: 247,
          column: 10
        },
        end: {
          line: 305,
          column: 13
        }
      },
      '103': {
        start: {
          line: 249,
          column: 25
        },
        end: {
          line: 249,
          column: 27
        }
      },
      '104': {
        start: {
          line: 250,
          column: 32
        },
        end: {
          line: 250,
          column: 34
        }
      },
      '105': {
        start: {
          line: 251,
          column: 12
        },
        end: {
          line: 253,
          column: 13
        }
      },
      '106': {
        start: {
          line: 252,
          column: 14
        },
        end: {
          line: 252,
          column: 44
        }
      },
      '107': {
        start: {
          line: 255,
          column: 12
        },
        end: {
          line: 275,
          column: 13
        }
      },
      '108': {
        start: {
          line: 256,
          column: 27
        },
        end: {
          line: 271,
          column: 16
        }
      },
      '109': {
        start: {
          line: 257,
          column: 16
        },
        end: {
          line: 264,
          column: 17
        }
      },
      '110': {
        start: {
          line: 258,
          column: 28
        },
        end: {
          line: 258,
          column: 44
        }
      },
      '111': {
        start: {
          line: 259,
          column: 18
        },
        end: {
          line: 262,
          column: 19
        }
      },
      '112': {
        start: {
          line: 260,
          column: 20
        },
        end: {
          line: 260,
          column: 28
        }
      },
      '113': {
        start: {
          line: 261,
          column: 20
        },
        end: {
          line: 261,
          column: 44
        }
      },
      '114': {
        start: {
          line: 263,
          column: 18
        },
        end: {
          line: 263,
          column: 28
        }
      },
      '115': {
        start: {
          line: 265,
          column: 16
        },
        end: {
          line: 265,
          column: 40
        }
      },
      '116': {
        start: {
          line: 267,
          column: 16
        },
        end: {
          line: 269,
          column: 17
        }
      },
      '117': {
        start: {
          line: 268,
          column: 18
        },
        end: {
          line: 268,
          column: 31
        }
      },
      '118': {
        start: {
          line: 270,
          column: 16
        },
        end: {
          line: 270,
          column: 46
        }
      },
      '119': {
        start: {
          line: 272,
          column: 14
        },
        end: {
          line: 274,
          column: 15
        }
      },
      '120': {
        start: {
          line: 273,
          column: 16
        },
        end: {
          line: 273,
          column: 43
        }
      },
      '121': {
        start: {
          line: 277,
          column: 28
        },
        end: {
          line: 277,
          column: 73
        }
      },
      '122': {
        start: {
          line: 278,
          column: 12
        },
        end: {
          line: 303,
          column: 13
        }
      },
      '123': {
        start: {
          line: 279,
          column: 14
        },
        end: {
          line: 281,
          column: 15
        }
      },
      '124': {
        start: {
          line: 280,
          column: 16
        },
        end: {
          line: 280,
          column: 25
        }
      },
      '125': {
        start: {
          line: 282,
          column: 28
        },
        end: {
          line: 288,
          column: 15
        }
      },
      '126': {
        start: {
          line: 289,
          column: 14
        },
        end: {
          line: 301,
          column: 15
        }
      },
      '127': {
        start: {
          line: 290,
          column: 16
        },
        end: {
          line: 300,
          column: 19
        }
      },
      '128': {
        start: {
          line: 302,
          column: 14
        },
        end: {
          line: 302,
          column: 34
        }
      },
      '129': {
        start: {
          line: 304,
          column: 12
        },
        end: {
          line: 304,
          column: 51
        }
      },
      '130': {
        start: {
          line: 309,
          column: 6
        },
        end: {
          line: 385,
          column: 9
        }
      },
      '131': {
        start: {
          line: 310,
          column: 19
        },
        end: {
          line: 310,
          column: 21
        }
      },
      '132': {
        start: {
          line: 311,
          column: 23
        },
        end: {
          line: 311,
          column: 70
        }
      },
      '133': {
        start: {
          line: 312,
          column: 23
        },
        end: {
          line: 314,
          column: 9
        }
      },
      '134': {
        start: {
          line: 313,
          column: 10
        },
        end: {
          line: 313,
          column: 20
        }
      },
      '135': {
        start: {
          line: 315,
          column: 21
        },
        end: {
          line: 317,
          column: 9
        }
      },
      '136': {
        start: {
          line: 316,
          column: 10
        },
        end: {
          line: 316,
          column: 22
        }
      },
      '137': {
        start: {
          line: 318,
          column: 8
        },
        end: {
          line: 382,
          column: 9
        }
      },
      '138': {
        start: {
          line: 320,
          column: 12
        },
        end: {
          line: 320,
          column: 34
        }
      },
      '139': {
        start: {
          line: 321,
          column: 12
        },
        end: {
          line: 321,
          column: 44
        }
      },
      '140': {
        start: {
          line: 322,
          column: 22
        },
        end: {
          line: 322,
          column: 47
        }
      },
      '141': {
        start: {
          line: 323,
          column: 12
        },
        end: {
          line: 325,
          column: 15
        }
      },
      '142': {
        start: {
          line: 324,
          column: 14
        },
        end: {
          line: 324,
          column: 118
        }
      },
      '143': {
        start: {
          line: 326,
          column: 12
        },
        end: {
          line: 328,
          column: 15
        }
      },
      '144': {
        start: {
          line: 327,
          column: 14
        },
        end: {
          line: 327,
          column: 62
        }
      },
      '145': {
        start: {
          line: 329,
          column: 12
        },
        end: {
          line: 329,
          column: 18
        }
      },
      '146': {
        start: {
          line: 331,
          column: 12
        },
        end: {
          line: 331,
          column: 29
        }
      },
      '147': {
        start: {
          line: 332,
          column: 12
        },
        end: {
          line: 339,
          column: 13
        }
      },
      '148': {
        start: {
          line: 333,
          column: 14
        },
        end: {
          line: 335,
          column: 17
        }
      },
      '149': {
        start: {
          line: 334,
          column: 16
        },
        end: {
          line: 334,
          column: 130
        }
      },
      '150': {
        start: {
          line: 336,
          column: 14
        },
        end: {
          line: 338,
          column: 17
        }
      },
      '151': {
        start: {
          line: 337,
          column: 16
        },
        end: {
          line: 337,
          column: 72
        }
      },
      '152': {
        start: {
          line: 341,
          column: 12
        },
        end: {
          line: 351,
          column: 13
        }
      },
      '153': {
        start: {
          line: 342,
          column: 14
        },
        end: {
          line: 342,
          column: 43
        }
      },
      '154': {
        start: {
          line: 343,
          column: 14
        },
        end: {
          line: 343,
          column: 35
        }
      },
      '155': {
        start: {
          line: 344,
          column: 14
        },
        end: {
          line: 347,
          column: 17
        }
      },
      '156': {
        start: {
          line: 345,
          column: 27
        },
        end: {
          line: 345,
          column: 91
        }
      },
      '157': {
        start: {
          line: 346,
          column: 16
        },
        end: {
          line: 346,
          column: 98
        }
      },
      '158': {
        start: {
          line: 348,
          column: 14
        },
        end: {
          line: 350,
          column: 17
        }
      },
      '159': {
        start: {
          line: 349,
          column: 16
        },
        end: {
          line: 349,
          column: 78
        }
      },
      '160': {
        start: {
          line: 352,
          column: 12
        },
        end: {
          line: 352,
          column: 18
        }
      },
      '161': {
        start: {
          line: 354,
          column: 12
        },
        end: {
          line: 354,
          column: 31
        }
      },
      '162': {
        start: {
          line: 355,
          column: 12
        },
        end: {
          line: 355,
          column: 44
        }
      },
      '163': {
        start: {
          line: 356,
          column: 12
        },
        end: {
          line: 358,
          column: 15
        }
      },
      '164': {
        start: {
          line: 357,
          column: 14
        },
        end: {
          line: 357,
          column: 107
        }
      },
      '165': {
        start: {
          line: 359,
          column: 12
        },
        end: {
          line: 361,
          column: 15
        }
      },
      '166': {
        start: {
          line: 360,
          column: 14
        },
        end: {
          line: 360,
          column: 60
        }
      },
      '167': {
        start: {
          line: 362,
          column: 12
        },
        end: {
          line: 362,
          column: 18
        }
      },
      '168': {
        start: {
          line: 364,
          column: 12
        },
        end: {
          line: 364,
          column: 33
        }
      },
      '169': {
        start: {
          line: 365,
          column: 12
        },
        end: {
          line: 367,
          column: 15
        }
      },
      '170': {
        start: {
          line: 366,
          column: 14
        },
        end: {
          line: 366,
          column: 62
        }
      },
      '171': {
        start: {
          line: 368,
          column: 12
        },
        end: {
          line: 370,
          column: 15
        }
      },
      '172': {
        start: {
          line: 369,
          column: 14
        },
        end: {
          line: 369,
          column: 68
        }
      },
      '173': {
        start: {
          line: 371,
          column: 12
        },
        end: {
          line: 371,
          column: 18
        }
      },
      '174': {
        start: {
          line: 373,
          column: 12
        },
        end: {
          line: 373,
          column: 38
        }
      },
      '175': {
        start: {
          line: 374,
          column: 12
        },
        end: {
          line: 376,
          column: 15
        }
      },
      '176': {
        start: {
          line: 375,
          column: 14
        },
        end: {
          line: 375,
          column: 85
        }
      },
      '177': {
        start: {
          line: 377,
          column: 12
        },
        end: {
          line: 379,
          column: 15
        }
      },
      '178': {
        start: {
          line: 378,
          column: 14
        },
        end: {
          line: 378,
          column: 64
        }
      },
      '179': {
        start: {
          line: 380,
          column: 12
        },
        end: {
          line: 380,
          column: 18
        }
      },
      '180': {
        start: {
          line: 384,
          column: 8
        },
        end: {
          line: 384,
          column: 52
        }
      },
      '181': {
        start: {
          line: 387,
          column: 6
        },
        end: {
          line: 387,
          column: 42
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 1,
            column: 58
          },
          end: {
            line: 1,
            column: 59
          }
        },
        loc: {
          start: {
            line: 1,
            column: 64
          },
          end: {
            line: 390,
            column: 1
          }
        },
        line: 1
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 16,
            column: 31
          },
          end: {
            line: 16,
            column: 32
          }
        },
        loc: {
          start: {
            line: 16,
            column: 48
          },
          end: {
            line: 45,
            column: 7
          }
        },
        line: 16
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 72,
            column: 28
          },
          end: {
            line: 72,
            column: 29
          }
        },
        loc: {
          start: {
            line: 72,
            column: 44
          },
          end: {
            line: 78,
            column: 7
          }
        },
        line: 72
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 80,
            column: 26
          },
          end: {
            line: 80,
            column: 27
          }
        },
        loc: {
          start: {
            line: 80,
            column: 38
          },
          end: {
            line: 86,
            column: 7
          }
        },
        line: 80
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 156,
            column: 25
          },
          end: {
            line: 156,
            column: 26
          }
        },
        loc: {
          start: {
            line: 156,
            column: 56
          },
          end: {
            line: 217,
            column: 7
          }
        },
        line: 156
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 175,
            column: 35
          },
          end: {
            line: 175,
            column: 36
          }
        },
        loc: {
          start: {
            line: 175,
            column: 46
          },
          end: {
            line: 177,
            column: 13
          }
        },
        line: 175
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 213,
            column: 17
          },
          end: {
            line: 213,
            column: 18
          }
        },
        loc: {
          start: {
            line: 213,
            column: 23
          },
          end: {
            line: 216,
            column: 9
          }
        },
        line: 213
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 219,
            column: 30
          },
          end: {
            line: 219,
            column: 31
          }
        },
        loc: {
          start: {
            line: 219,
            column: 46
          },
          end: {
            line: 307,
            column: 7
          }
        },
        line: 219
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 222,
            column: 46
          },
          end: {
            line: 222,
            column: 47
          }
        },
        loc: {
          start: {
            line: 222,
            column: 54
          },
          end: {
            line: 306,
            column: 9
          }
        },
        line: 222
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 247,
            column: 50
          },
          end: {
            line: 247,
            column: 51
          }
        },
        loc: {
          start: {
            line: 247,
            column: 58
          },
          end: {
            line: 305,
            column: 11
          }
        },
        line: 247
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 256,
            column: 49
          },
          end: {
            line: 256,
            column: 50
          }
        },
        loc: {
          start: {
            line: 256,
            column: 58
          },
          end: {
            line: 266,
            column: 15
          }
        },
        line: 256
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 266,
            column: 24
          },
          end: {
            line: 266,
            column: 25
          }
        },
        loc: {
          start: {
            line: 266,
            column: 33
          },
          end: {
            line: 271,
            column: 15
          }
        },
        line: 266
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 309,
            column: 32
          },
          end: {
            line: 309,
            column: 33
          }
        },
        loc: {
          start: {
            line: 309,
            column: 40
          },
          end: {
            line: 385,
            column: 7
          }
        },
        line: 309
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 312,
            column: 23
          },
          end: {
            line: 312,
            column: 24
          }
        },
        loc: {
          start: {
            line: 312,
            column: 29
          },
          end: {
            line: 314,
            column: 9
          }
        },
        line: 312
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 315,
            column: 21
          },
          end: {
            line: 315,
            column: 22
          }
        },
        loc: {
          start: {
            line: 315,
            column: 39
          },
          end: {
            line: 317,
            column: 9
          }
        },
        line: 315
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 323,
            column: 23
          },
          end: {
            line: 323,
            column: 24
          }
        },
        loc: {
          start: {
            line: 323,
            column: 32
          },
          end: {
            line: 325,
            column: 13
          }
        },
        line: 323
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 326,
            column: 21
          },
          end: {
            line: 326,
            column: 22
          }
        },
        loc: {
          start: {
            line: 326,
            column: 39
          },
          end: {
            line: 328,
            column: 13
          }
        },
        line: 326
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 333,
            column: 25
          },
          end: {
            line: 333,
            column: 26
          }
        },
        loc: {
          start: {
            line: 333,
            column: 34
          },
          end: {
            line: 335,
            column: 15
          }
        },
        line: 333
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 336,
            column: 23
          },
          end: {
            line: 336,
            column: 24
          }
        },
        loc: {
          start: {
            line: 336,
            column: 41
          },
          end: {
            line: 338,
            column: 15
          }
        },
        line: 336
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 344,
            column: 25
          },
          end: {
            line: 344,
            column: 26
          }
        },
        loc: {
          start: {
            line: 344,
            column: 51
          },
          end: {
            line: 347,
            column: 15
          }
        },
        line: 344
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 348,
            column: 23
          },
          end: {
            line: 348,
            column: 24
          }
        },
        loc: {
          start: {
            line: 348,
            column: 41
          },
          end: {
            line: 350,
            column: 15
          }
        },
        line: 348
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 356,
            column: 23
          },
          end: {
            line: 356,
            column: 24
          }
        },
        loc: {
          start: {
            line: 356,
            column: 32
          },
          end: {
            line: 358,
            column: 13
          }
        },
        line: 356
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 359,
            column: 21
          },
          end: {
            line: 359,
            column: 22
          }
        },
        loc: {
          start: {
            line: 359,
            column: 39
          },
          end: {
            line: 361,
            column: 13
          }
        },
        line: 359
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 365,
            column: 23
          },
          end: {
            line: 365,
            column: 24
          }
        },
        loc: {
          start: {
            line: 365,
            column: 32
          },
          end: {
            line: 367,
            column: 13
          }
        },
        line: 365
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 368,
            column: 21
          },
          end: {
            line: 368,
            column: 22
          }
        },
        loc: {
          start: {
            line: 368,
            column: 39
          },
          end: {
            line: 370,
            column: 13
          }
        },
        line: 368
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 374,
            column: 23
          },
          end: {
            line: 374,
            column: 24
          }
        },
        loc: {
          start: {
            line: 374,
            column: 32
          },
          end: {
            line: 376,
            column: 13
          }
        },
        line: 374
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 377,
            column: 21
          },
          end: {
            line: 377,
            column: 22
          }
        },
        loc: {
          start: {
            line: 377,
            column: 39
          },
          end: {
            line: 379,
            column: 13
          }
        },
        line: 377
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 17,
            column: 8
          },
          end: {
            line: 44,
            column: 9
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 18,
            column: 10
          },
          end: {
            line: 18,
            column: 18
          }
        }, {
          start: {
            line: 18,
            column: 19
          },
          end: {
            line: 19,
            column: 121
          }
        }, {
          start: {
            line: 20,
            column: 10
          },
          end: {
            line: 20,
            column: 18
          }
        }, {
          start: {
            line: 20,
            column: 19
          },
          end: {
            line: 21,
            column: 119
          }
        }, {
          start: {
            line: 22,
            column: 10
          },
          end: {
            line: 22,
            column: 18
          }
        }, {
          start: {
            line: 22,
            column: 19
          },
          end: {
            line: 23,
            column: 124
          }
        }, {
          start: {
            line: 24,
            column: 10
          },
          end: {
            line: 24,
            column: 17
          }
        }, {
          start: {
            line: 24,
            column: 18
          },
          end: {
            line: 25,
            column: 122
          }
        }, {
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 17
          }
        }, {
          start: {
            line: 26,
            column: 18
          },
          end: {
            line: 27,
            column: 110
          }
        }, {
          start: {
            line: 28,
            column: 10
          },
          end: {
            line: 28,
            column: 17
          }
        }, {
          start: {
            line: 28,
            column: 18
          },
          end: {
            line: 29,
            column: 110
          }
        }, {
          start: {
            line: 30,
            column: 10
          },
          end: {
            line: 30,
            column: 17
          }
        }, {
          start: {
            line: 30,
            column: 18
          },
          end: {
            line: 31,
            column: 110
          }
        }, {
          start: {
            line: 32,
            column: 10
          },
          end: {
            line: 32,
            column: 17
          }
        }, {
          start: {
            line: 32,
            column: 18
          },
          end: {
            line: 33,
            column: 110
          }
        }, {
          start: {
            line: 34,
            column: 10
          },
          end: {
            line: 34,
            column: 17
          }
        }, {
          start: {
            line: 34,
            column: 18
          },
          end: {
            line: 35,
            column: 110
          }
        }, {
          start: {
            line: 36,
            column: 10
          },
          end: {
            line: 36,
            column: 17
          }
        }, {
          start: {
            line: 36,
            column: 18
          },
          end: {
            line: 37,
            column: 110
          }
        }, {
          start: {
            line: 38,
            column: 10
          },
          end: {
            line: 38,
            column: 17
          }
        }, {
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 39,
            column: 110
          }
        }, {
          start: {
            line: 40,
            column: 10
          },
          end: {
            line: 40,
            column: 17
          }
        }, {
          start: {
            line: 40,
            column: 18
          },
          end: {
            line: 41,
            column: 110
          }
        }, {
          start: {
            line: 42,
            column: 10
          },
          end: {
            line: 43,
            column: 110
          }
        }],
        line: 17
      },
      '1': {
        loc: {
          start: {
            line: 48,
            column: 10
          },
          end: {
            line: 50,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 48,
            column: 10
          },
          end: {
            line: 50,
            column: 11
          }
        }, {
          start: {
            line: 48,
            column: 10
          },
          end: {
            line: 50,
            column: 11
          }
        }],
        line: 48
      },
      '2': {
        loc: {
          start: {
            line: 54,
            column: 62
          },
          end: {
            line: 54,
            column: 121
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 54,
            column: 97
          },
          end: {
            line: 54,
            column: 111
          }
        }, {
          start: {
            line: 54,
            column: 115
          },
          end: {
            line: 54,
            column: 120
          }
        }],
        line: 54
      },
      '3': {
        loc: {
          start: {
            line: 57,
            column: 27
          },
          end: {
            line: 64,
            column: 11
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 57,
            column: 66
          },
          end: {
            line: 61,
            column: 11
          }
        }, {
          start: {
            line: 61,
            column: 14
          },
          end: {
            line: 64,
            column: 11
          }
        }],
        line: 57
      },
      '4': {
        loc: {
          start: {
            line: 57,
            column: 28
          },
          end: {
            line: 57,
            column: 62
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 57,
            column: 28
          },
          end: {
            line: 57,
            column: 43
          }
        }, {
          start: {
            line: 57,
            column: 47
          },
          end: {
            line: 57,
            column: 62
          }
        }],
        line: 57
      },
      '5': {
        loc: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 75,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 75,
            column: 9
          }
        }, {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 75,
            column: 9
          }
        }],
        line: 73
      },
      '6': {
        loc: {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }],
        line: 81
      },
      '7': {
        loc: {
          start: {
            line: 93,
            column: 26
          },
          end: {
            line: 93,
            column: 62
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 93,
            column: 26
          },
          end: {
            line: 93,
            column: 46
          }
        }, {
          start: {
            line: 93,
            column: 50
          },
          end: {
            line: 93,
            column: 62
          }
        }],
        line: 93
      },
      '8': {
        loc: {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 128,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 128,
            column: 13
          }
        }, {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 128,
            column: 13
          }
        }],
        line: 126
      },
      '9': {
        loc: {
          start: {
            line: 139,
            column: 10
          },
          end: {
            line: 141,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 139,
            column: 10
          },
          end: {
            line: 141,
            column: 11
          }
        }, {
          start: {
            line: 139,
            column: 10
          },
          end: {
            line: 141,
            column: 11
          }
        }],
        line: 139
      },
      '10': {
        loc: {
          start: {
            line: 146,
            column: 26
          },
          end: {
            line: 146,
            column: 62
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 146,
            column: 26
          },
          end: {
            line: 146,
            column: 46
          }
        }, {
          start: {
            line: 146,
            column: 50
          },
          end: {
            line: 146,
            column: 62
          }
        }],
        line: 146
      },
      '11': {
        loc: {
          start: {
            line: 165,
            column: 12
          },
          end: {
            line: 167,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 165,
            column: 12
          },
          end: {
            line: 167,
            column: 13
          }
        }, {
          start: {
            line: 165,
            column: 12
          },
          end: {
            line: 167,
            column: 13
          }
        }],
        line: 165
      },
      '12': {
        loc: {
          start: {
            line: 168,
            column: 12
          },
          end: {
            line: 170,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 168,
            column: 12
          },
          end: {
            line: 170,
            column: 13
          }
        }, {
          start: {
            line: 168,
            column: 12
          },
          end: {
            line: 170,
            column: 13
          }
        }],
        line: 168
      },
      '13': {
        loc: {
          start: {
            line: 168,
            column: 16
          },
          end: {
            line: 168,
            column: 68
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 168,
            column: 16
          },
          end: {
            line: 168,
            column: 40
          }
        }, {
          start: {
            line: 168,
            column: 44
          },
          end: {
            line: 168,
            column: 68
          }
        }],
        line: 168
      },
      '14': {
        loc: {
          start: {
            line: 171,
            column: 12
          },
          end: {
            line: 173,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 171,
            column: 12
          },
          end: {
            line: 173,
            column: 13
          }
        }, {
          start: {
            line: 171,
            column: 12
          },
          end: {
            line: 173,
            column: 13
          }
        }],
        line: 171
      },
      '15': {
        loc: {
          start: {
            line: 188,
            column: 12
          },
          end: {
            line: 190,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 188,
            column: 12
          },
          end: {
            line: 190,
            column: 13
          }
        }, {
          start: {
            line: 188,
            column: 12
          },
          end: {
            line: 190,
            column: 13
          }
        }],
        line: 188
      },
      '16': {
        loc: {
          start: {
            line: 191,
            column: 12
          },
          end: {
            line: 193,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 191,
            column: 12
          },
          end: {
            line: 193,
            column: 13
          }
        }, {
          start: {
            line: 191,
            column: 12
          },
          end: {
            line: 193,
            column: 13
          }
        }],
        line: 191
      },
      '17': {
        loc: {
          start: {
            line: 194,
            column: 12
          },
          end: {
            line: 196,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 194,
            column: 12
          },
          end: {
            line: 196,
            column: 13
          }
        }, {
          start: {
            line: 194,
            column: 12
          },
          end: {
            line: 196,
            column: 13
          }
        }],
        line: 194
      },
      '18': {
        loc: {
          start: {
            line: 197,
            column: 12
          },
          end: {
            line: 199,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 197,
            column: 12
          },
          end: {
            line: 199,
            column: 13
          }
        }, {
          start: {
            line: 197,
            column: 12
          },
          end: {
            line: 199,
            column: 13
          }
        }],
        line: 197
      },
      '19': {
        loc: {
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 211,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 211,
            column: 9
          }
        }, {
          start: {
            line: 205,
            column: 8
          },
          end: {
            line: 211,
            column: 9
          }
        }],
        line: 205
      },
      '20': {
        loc: {
          start: {
            line: 225,
            column: 20
          },
          end: {
            line: 225,
            column: 53
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 225,
            column: 44
          },
          end: {
            line: 225,
            column: 48
          }
        }, {
          start: {
            line: 225,
            column: 51
          },
          end: {
            line: 225,
            column: 53
          }
        }],
        line: 225
      },
      '21': {
        loc: {
          start: {
            line: 226,
            column: 10
          },
          end: {
            line: 228,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 226,
            column: 10
          },
          end: {
            line: 228,
            column: 11
          }
        }, {
          start: {
            line: 226,
            column: 10
          },
          end: {
            line: 228,
            column: 11
          }
        }],
        line: 226
      },
      '22': {
        loc: {
          start: {
            line: 229,
            column: 10
          },
          end: {
            line: 231,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 229,
            column: 10
          },
          end: {
            line: 231,
            column: 11
          }
        }, {
          start: {
            line: 229,
            column: 10
          },
          end: {
            line: 231,
            column: 11
          }
        }],
        line: 229
      },
      '23': {
        loc: {
          start: {
            line: 229,
            column: 14
          },
          end: {
            line: 229,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 229,
            column: 14
          },
          end: {
            line: 229,
            column: 19
          }
        }, {
          start: {
            line: 229,
            column: 23
          },
          end: {
            line: 229,
            column: 47
          }
        }],
        line: 229
      },
      '24': {
        loc: {
          start: {
            line: 232,
            column: 10
          },
          end: {
            line: 234,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 232,
            column: 10
          },
          end: {
            line: 234,
            column: 11
          }
        }, {
          start: {
            line: 232,
            column: 10
          },
          end: {
            line: 234,
            column: 11
          }
        }],
        line: 232
      },
      '25': {
        loc: {
          start: {
            line: 241,
            column: 16
          },
          end: {
            line: 241,
            column: 35
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 241,
            column: 23
          },
          end: {
            line: 241,
            column: 30
          }
        }, {
          start: {
            line: 241,
            column: 33
          },
          end: {
            line: 241,
            column: 35
          }
        }],
        line: 241
      },
      '26': {
        loc: {
          start: {
            line: 243,
            column: 17
          },
          end: {
            line: 243,
            column: 45
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 243,
            column: 25
          },
          end: {
            line: 243,
            column: 40
          }
        }, {
          start: {
            line: 243,
            column: 44
          },
          end: {
            line: 243,
            column: 45
          }
        }],
        line: 243
      },
      '27': {
        loc: {
          start: {
            line: 243,
            column: 25
          },
          end: {
            line: 243,
            column: 40
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 243,
            column: 25
          },
          end: {
            line: 243,
            column: 35
          }
        }, {
          start: {
            line: 243,
            column: 39
          },
          end: {
            line: 243,
            column: 40
          }
        }],
        line: 243
      },
      '28': {
        loc: {
          start: {
            line: 257,
            column: 16
          },
          end: {
            line: 264,
            column: 17
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 257,
            column: 16
          },
          end: {
            line: 264,
            column: 17
          }
        }, {
          start: {
            line: 257,
            column: 16
          },
          end: {
            line: 264,
            column: 17
          }
        }],
        line: 257
      },
      '29': {
        loc: {
          start: {
            line: 259,
            column: 18
          },
          end: {
            line: 262,
            column: 19
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 259,
            column: 18
          },
          end: {
            line: 262,
            column: 19
          }
        }, {
          start: {
            line: 259,
            column: 18
          },
          end: {
            line: 262,
            column: 19
          }
        }],
        line: 259
      },
      '30': {
        loc: {
          start: {
            line: 267,
            column: 16
          },
          end: {
            line: 269,
            column: 17
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 267,
            column: 16
          },
          end: {
            line: 269,
            column: 17
          }
        }, {
          start: {
            line: 267,
            column: 16
          },
          end: {
            line: 269,
            column: 17
          }
        }],
        line: 267
      },
      '31': {
        loc: {
          start: {
            line: 279,
            column: 14
          },
          end: {
            line: 281,
            column: 15
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 279,
            column: 14
          },
          end: {
            line: 281,
            column: 15
          }
        }, {
          start: {
            line: 279,
            column: 14
          },
          end: {
            line: 281,
            column: 15
          }
        }],
        line: 279
      },
      '32': {
        loc: {
          start: {
            line: 279,
            column: 31
          },
          end: {
            line: 279,
            column: 74
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 279,
            column: 31
          },
          end: {
            line: 279,
            column: 44
          }
        }, {
          start: {
            line: 279,
            column: 48
          },
          end: {
            line: 279,
            column: 62
          }
        }, {
          start: {
            line: 279,
            column: 66
          },
          end: {
            line: 279,
            column: 74
          }
        }],
        line: 279
      },
      '33': {
        loc: {
          start: {
            line: 287,
            column: 90
          },
          end: {
            line: 287,
            column: 178
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 287,
            column: 98
          },
          end: {
            line: 287,
            column: 173
          }
        }, {
          start: {
            line: 287,
            column: 177
          },
          end: {
            line: 287,
            column: 178
          }
        }],
        line: 287
      },
      '34': {
        loc: {
          start: {
            line: 287,
            column: 98
          },
          end: {
            line: 287,
            column: 173
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 287,
            column: 125
          },
          end: {
            line: 287,
            column: 135
          }
        }, {
          start: {
            line: 287,
            column: 139
          },
          end: {
            line: 287,
            column: 172
          }
        }],
        line: 287
      },
      '35': {
        loc: {
          start: {
            line: 287,
            column: 148
          },
          end: {
            line: 287,
            column: 163
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 287,
            column: 148
          },
          end: {
            line: 287,
            column: 158
          }
        }, {
          start: {
            line: 287,
            column: 162
          },
          end: {
            line: 287,
            column: 163
          }
        }],
        line: 287
      },
      '36': {
        loc: {
          start: {
            line: 318,
            column: 8
          },
          end: {
            line: 382,
            column: 9
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 319,
            column: 10
          },
          end: {
            line: 329,
            column: 18
          }
        }, {
          start: {
            line: 330,
            column: 10
          },
          end: {
            line: 352,
            column: 18
          }
        }, {
          start: {
            line: 353,
            column: 10
          },
          end: {
            line: 362,
            column: 18
          }
        }, {
          start: {
            line: 363,
            column: 10
          },
          end: {
            line: 371,
            column: 18
          }
        }, {
          start: {
            line: 372,
            column: 10
          },
          end: {
            line: 380,
            column: 18
          }
        }, {
          start: {
            line: 381,
            column: 10
          },
          end: {
            line: 381,
            column: 18
          }
        }],
        line: 318
      },
      '37': {
        loc: {
          start: {
            line: 321,
            column: 24
          },
          end: {
            line: 321,
            column: 43
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 321,
            column: 31
          },
          end: {
            line: 321,
            column: 39
          }
        }, {
          start: {
            line: 321,
            column: 42
          },
          end: {
            line: 321,
            column: 43
          }
        }],
        line: 321
      },
      '38': {
        loc: {
          start: {
            line: 322,
            column: 22
          },
          end: {
            line: 322,
            column: 47
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 322,
            column: 29
          },
          end: {
            line: 322,
            column: 43
          }
        }, {
          start: {
            line: 322,
            column: 46
          },
          end: {
            line: 322,
            column: 47
          }
        }],
        line: 322
      },
      '39': {
        loc: {
          start: {
            line: 327,
            column: 21
          },
          end: {
            line: 327,
            column: 61
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 327,
            column: 55
          },
          end: {
            line: 327,
            column: 56
          }
        }, {
          start: {
            line: 327,
            column: 59
          },
          end: {
            line: 327,
            column: 61
          }
        }],
        line: 327
      },
      '40': {
        loc: {
          start: {
            line: 332,
            column: 12
          },
          end: {
            line: 339,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 332,
            column: 12
          },
          end: {
            line: 339,
            column: 13
          }
        }, {
          start: {
            line: 332,
            column: 12
          },
          end: {
            line: 339,
            column: 13
          }
        }],
        line: 332
      },
      '41': {
        loc: {
          start: {
            line: 337,
            column: 23
          },
          end: {
            line: 337,
            column: 71
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 337,
            column: 65
          },
          end: {
            line: 337,
            column: 66
          }
        }, {
          start: {
            line: 337,
            column: 69
          },
          end: {
            line: 337,
            column: 71
          }
        }],
        line: 337
      },
      '42': {
        loc: {
          start: {
            line: 341,
            column: 12
          },
          end: {
            line: 351,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 341,
            column: 12
          },
          end: {
            line: 351,
            column: 13
          }
        }, {
          start: {
            line: 341,
            column: 12
          },
          end: {
            line: 351,
            column: 13
          }
        }],
        line: 341
      },
      '43': {
        loc: {
          start: {
            line: 349,
            column: 23
          },
          end: {
            line: 349,
            column: 77
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 349,
            column: 71
          },
          end: {
            line: 349,
            column: 72
          }
        }, {
          start: {
            line: 349,
            column: 75
          },
          end: {
            line: 349,
            column: 77
          }
        }],
        line: 349
      },
      '44': {
        loc: {
          start: {
            line: 355,
            column: 24
          },
          end: {
            line: 355,
            column: 43
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 355,
            column: 31
          },
          end: {
            line: 355,
            column: 39
          }
        }, {
          start: {
            line: 355,
            column: 42
          },
          end: {
            line: 355,
            column: 43
          }
        }],
        line: 355
      },
      '45': {
        loc: {
          start: {
            line: 360,
            column: 21
          },
          end: {
            line: 360,
            column: 59
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 360,
            column: 53
          },
          end: {
            line: 360,
            column: 54
          }
        }, {
          start: {
            line: 360,
            column: 57
          },
          end: {
            line: 360,
            column: 59
          }
        }],
        line: 360
      },
      '46': {
        loc: {
          start: {
            line: 369,
            column: 21
          },
          end: {
            line: 369,
            column: 67
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 369,
            column: 61
          },
          end: {
            line: 369,
            column: 62
          }
        }, {
          start: {
            line: 369,
            column: 65
          },
          end: {
            line: 369,
            column: 67
          }
        }],
        line: 369
      },
      '47': {
        loc: {
          start: {
            line: 378,
            column: 21
          },
          end: {
            line: 378,
            column: 63
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 378,
            column: 57
          },
          end: {
            line: 378,
            column: 58
          }
        }, {
          start: {
            line: 378,
            column: 61
          },
          end: {
            line: 378,
            column: 63
          }
        }],
        line: 378
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0
    },
    b: {
      '0': [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0, 0],
      '32': [0, 0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0, 0, 0, 0, 0],
      '37': [0, 0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0, 0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0, 0],
      '47': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_3je0ixb3g.s[0]++;
angular.module('app').directive('dashboardTableActivity', function () {
  cov_3je0ixb3g.f[0]++;
  cov_3je0ixb3g.s[1]++;

  return {
    restrict: 'E',
    scope: {
      data: '=',
      idWidget: '=',
      analyse: '=',
      titleDashboard: '@'
    },
    templateUrl: 'app/views/common/dashboard-table-activity.html',
    controller: function controller($scope, $rootScope, $LOGINService, $translate, $filter, $CRUDService, $timeout) {
      cov_3je0ixb3g.s[2]++;

      $scope.ISINCLUDEDRAPPORT = $rootScope.getISINCLUDEDRAPPORT();
      var PATH = (cov_3je0ixb3g.s[3]++, 'Analyse');
      cov_3je0ixb3g.s[4]++;
      $scope.isProcess = false;
      cov_3je0ixb3g.s[5]++;
      $scope.ID_COMPONENT = $scope.idWidget;
      cov_3je0ixb3g.s[6]++;
      $scope.getCorrectIndex = function (index) {
        cov_3je0ixb3g.f[1]++;
        cov_3je0ixb3g.s[7]++;

        switch (index) {
          case 12:
            cov_3je0ixb3g.b[0][0]++;
          case '12':
            cov_3je0ixb3g.b[0][1]++;
            cov_3je0ixb3g.s[8]++;

            return { id: 'DD', label: $translate.instant('ANALYSE.FIELDS.DATE.BEGIN_PLAN'), format: 'medium', width: 100 };
          case 11:
            cov_3je0ixb3g.b[0][2]++;
          case '11':
            cov_3je0ixb3g.b[0][3]++;
            cov_3je0ixb3g.s[9]++;

            return { id: 'DF', label: $translate.instant('ANALYSE.FIELDS.DATE.END_PLAN'), format: 'medium', width: 100 };
          case 10:
            cov_3je0ixb3g.b[0][4]++;
          case '10':
            cov_3je0ixb3g.b[0][5]++;
            cov_3je0ixb3g.s[10]++;

            return { id: 'DDR', label: $translate.instant('ANALYSE.FIELDS.DATE.BEGIN_ACTUAL'), format: 'medium', width: 100 };
          case 9:
            cov_3je0ixb3g.b[0][6]++;
          case '9':
            cov_3je0ixb3g.b[0][7]++;
            cov_3je0ixb3g.s[11]++;

            return { id: 'DFR', label: $translate.instant('ANALYSE.FIELDS.DATE.END_ACTUAL'), format: 'medium', width: 100 };
          case 8:
            cov_3je0ixb3g.b[0][8]++;
          case '8':
            cov_3je0ixb3g.b[0][9]++;
            cov_3je0ixb3g.s[12]++;

            return { id: 'BB', label: $translate.instant('ANALYSE.FIELDS.BUDGET.P'), format: 'N2', width: 150 };
          case 7:
            cov_3je0ixb3g.b[0][10]++;
          case '7':
            cov_3je0ixb3g.b[0][11]++;
            cov_3je0ixb3g.s[13]++;

            return { id: 'CB', label: $translate.instant('ANALYSE.FIELDS.BUDGET.R'), format: 'N2', width: 150 };
          case 6:
            cov_3je0ixb3g.b[0][12]++;
          case '6':
            cov_3je0ixb3g.b[0][13]++;
            cov_3je0ixb3g.s[14]++;

            return { id: 'EB', label: $translate.instant('ANALYSE.FIELDS.BUDGET.E'), format: 'N2', width: 150 };
          case 2:
            cov_3je0ixb3g.b[0][14]++;
          case '2':
            cov_3je0ixb3g.b[0][15]++;
            cov_3je0ixb3g.s[15]++;

            return { id: 'EP', label: $translate.instant('ANALYSE.FIELDS.PHYSIC.E'), format: 'N2', width: 100 };
          case 4:
            cov_3je0ixb3g.b[0][16]++;
          case '4':
            cov_3je0ixb3g.b[0][17]++;
            cov_3je0ixb3g.s[16]++;

            return { id: 'PP', label: $translate.instant('ANALYSE.FIELDS.PHYSIC.P'), format: 'N2', width: 100 };
          case 3:
            cov_3je0ixb3g.b[0][18]++;
          case '3':
            cov_3je0ixb3g.b[0][19]++;
            cov_3je0ixb3g.s[17]++;

            return { id: 'RP', label: $translate.instant('ANALYSE.FIELDS.PHYSIC.R'), format: 'N2', width: 100 };
          case 5:
            cov_3je0ixb3g.b[0][20]++;
          case '5':
            cov_3je0ixb3g.b[0][21]++;
            cov_3je0ixb3g.s[18]++;

            return { id: 'TB', label: $translate.instant('ANALYSE.FIELDS.BUDGET.T'), format: 'P2', width: 100 };
          case 1:
            cov_3je0ixb3g.b[0][22]++;
          case '1':
            cov_3je0ixb3g.b[0][23]++;
            cov_3je0ixb3g.s[19]++;

            return { id: 'TP', label: $translate.instant('ANALYSE.FIELDS.PHYSIC.T'), format: 'P2', width: 100 };
          default:
            cov_3je0ixb3g.b[0][24]++;
            cov_3je0ixb3g.s[20]++;

            return { id: 'TP', label: $translate.instant('ANALYSE.FIELDS.PHYSIC.T'), format: 'P2', width: 100 };
        }
      };
      cov_3je0ixb3g.s[21]++;
      $scope.process = {
        open: function open(item_) {
          cov_3je0ixb3g.s[22]++;

          if (!angular.isArray(item_.FIELD)) {
            cov_3je0ixb3g.b[1][0]++;
            cov_3je0ixb3g.s[23]++;

            item_.FIELD = [1, 2, 3, 4, 5, 6, 7, 8, 9];
          } else {
            cov_3je0ixb3g.b[1][1]++;
          }

          cov_3je0ixb3g.s[24]++;
          $scope.displayColumns = [];
          cov_3je0ixb3g.s[25]++;
          for (var i = 0; i < item_.FIELD.length; i++) {
            cov_3je0ixb3g.s[26]++;

            $scope.displayColumns.push($scope.getCorrectIndex(angular.isNumber(item_.FIELD[i]) ? (cov_3je0ixb3g.b[2][0]++, item_.FIELD[i]) : (cov_3je0ixb3g.b[2][1]++, i + 1)));
          }

          cov_3je0ixb3g.s[27]++;
          $scope.itemCol = (cov_3je0ixb3g.b[4][0]++, item_.AXE2 == 3) && (cov_3je0ixb3g.b[4][1]++, item_.AXE2 == 1) ? (cov_3je0ixb3g.b[3][0]++, {
            level: 0,
            id_: '',
            id: 0
          }) : (cov_3je0ixb3g.b[3][1]++, {
            id_: '',
            id: ''
          });

          cov_3je0ixb3g.s[28]++;
          $scope.listItem = [];

          cov_3je0ixb3g.s[29]++;
          $scope.processColumns();
        }
      };

      cov_3je0ixb3g.s[30]++;
      $scope.goToChildren = function (item) {
        cov_3je0ixb3g.f[2]++;
        cov_3je0ixb3g.s[31]++;

        if (item) {
          cov_3je0ixb3g.b[5][0]++;
          cov_3je0ixb3g.s[32]++;

          $scope.listItem.push(item);
        } else {
          cov_3je0ixb3g.b[5][1]++;
        }

        cov_3je0ixb3g.s[33]++;
        $scope.processColumns(item);
      };

      cov_3je0ixb3g.s[34]++;
      $scope.goToParent = function () {
        cov_3je0ixb3g.f[3]++;
        cov_3je0ixb3g.s[35]++;

        if ($scope.listItem == 0) {
          cov_3je0ixb3g.b[6][0]++;
          cov_3je0ixb3g.s[36]++;

          return;
        } else {
          cov_3je0ixb3g.b[6][1]++;
        }
        cov_3je0ixb3g.s[37]++;
        $scope.listItem.pop();
        cov_3je0ixb3g.s[38]++;
        $scope.goToChildren($scope.listItem.pop());
      };

      cov_3je0ixb3g.s[39]++;
      $scope.export = {
        pdf: function pdf() {
          var A4Size = (cov_3je0ixb3g.s[40]++, 1450);
          var pageSize = (cov_3je0ixb3g.s[41]++, 'A3');

          var title_ = (cov_3je0ixb3g.s[42]++, ((cov_3je0ixb3g.b[7][0]++, $scope.analyse.TITLE) || (cov_3je0ixb3g.b[7][1]++, 'new report')).toUpperCase());
          var pdfExportProperties = (cov_3je0ixb3g.s[43]++, {
            pageSize: 'A4',
            header: {
              fromTop: 0,
              height: 50,
              contents: [{
                type: 'Text',
                value: title_,
                position: { x: 0, y: 0 },
                style: { fontSize: 11, hAlign: 'Center', vAlign: 'Center' }
              }]
            },
            footer: {
              fromBottom: 0,
              height: 20,
              contents: [{
                type: 'PageNumber',
                pageNumberType: 'Arabic',
                format: '{$current} / {$total}',
                position: { x: 200, y: 0 },
                style: { textBrushColor: '#353535', fontSize: 9, hAlign: 'Center' }
              }]
            },
            pageOrientation: 'Landscape',
            fileName: title_ + '.pdf'
          });
          var width = (cov_3je0ixb3g.s[44]++, 0);
          cov_3je0ixb3g.s[45]++;
          for (var _iterator = $scope.treeGridObj.columns, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var column = _ref;
            cov_3je0ixb3g.s[46]++;

            if (!column.visible) {
              cov_3je0ixb3g.b[8][0]++;
              cov_3je0ixb3g.s[47]++;

              continue;
            } else {
              cov_3je0ixb3g.b[8][1]++;
            }
            cov_3je0ixb3g.s[48]++;
            width += parseFloat(column.width.toString().replace('px', ''));
          }

          var prop = (cov_3je0ixb3g.s[49]++, 1450 / width);
          cov_3je0ixb3g.s[50]++;
          for (var _iterator2 = $scope.treeGridObj.columns, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
              if (_i2 >= _iterator2.length) break;
              _ref2 = _iterator2[_i2++];
            } else {
              _i2 = _iterator2.next();
              if (_i2.done) break;
              _ref2 = _i2.value;
            }

            var _column = _ref2;
            cov_3je0ixb3g.s[51]++;

            width = parseFloat(_column.width.toString().replace('px', ''));
            cov_3je0ixb3g.s[52]++;
            _column.width = width * prop + 'px';
          }
          cov_3je0ixb3g.s[53]++;
          pdfExportProperties.footer.contents[0].position.x = A4Size - 50;
          cov_3je0ixb3g.s[54]++;
          pdfExportProperties.header.contents[0].position.x = (700 - 700 * title_.length / 104) / 2;
          cov_3je0ixb3g.s[55]++;
          if (pdfExportProperties.header.contents[0].position.x < 0) {
            cov_3je0ixb3g.b[9][0]++;
            cov_3je0ixb3g.s[56]++;

            pdfExportProperties.header.contents[0].position.x = 0;
          } else {
            cov_3je0ixb3g.b[9][1]++;
          }
          cov_3je0ixb3g.s[57]++;
          pdfExportProperties.pageSize = pageSize;
          cov_3je0ixb3g.s[58]++;
          $scope.treeGridObj.pdfExport(pdfExportProperties);
        },
        excel: function excel() {
          var title_ = (cov_3je0ixb3g.s[59]++, ((cov_3je0ixb3g.b[10][0]++, $scope.analyse.TITLE) || (cov_3je0ixb3g.b[10][1]++, 'new report')).toUpperCase());

          var excelExportProperties = (cov_3je0ixb3g.s[60]++, {
            fileName: title_ + '.xlsx'
          });

          cov_3je0ixb3g.s[61]++;
          $scope.treeGridObj.excelExport(excelExportProperties);
        }
      };

      cov_3je0ixb3g.s[62]++;
      $scope.drawTable = function (columns, dataSource) {
        cov_3je0ixb3g.f[4]++;

        var params = (cov_3je0ixb3g.s[63]++, {
          allowPdfExport: true,
          allowExcelExport: true,
          locale: $LOGINService.getLang(),
          idMapping: 'ID',
          parentIdMapping: 'ID_P',
          dataSource: dataSource,
          headerCellInfo: function headerCellInfo(target) {
            cov_3je0ixb3g.s[64]++;

            if (target.cell.cellType == 1) {
              cov_3je0ixb3g.b[11][0]++;
              cov_3je0ixb3g.s[65]++;

              return;
            } else {
              cov_3je0ixb3g.b[11][1]++;
            }
            cov_3je0ixb3g.s[66]++;
            if ((cov_3je0ixb3g.b[13][0]++, $scope.analyse.AXE1 == 4) || (cov_3je0ixb3g.b[13][1]++, $scope.analyse.AXE1 == 5)) {
              cov_3je0ixb3g.b[12][0]++;
              cov_3je0ixb3g.s[67]++;

              return;
            } else {
              cov_3je0ixb3g.b[12][1]++;
            }
            cov_3je0ixb3g.s[68]++;
            if ($scope.isProcess) {
              cov_3je0ixb3g.b[14][0]++;
              cov_3je0ixb3g.s[69]++;

              return;
            } else {
              cov_3je0ixb3g.b[14][1]++;
            }
            cov_3je0ixb3g.s[70]++;
            $scope.isProcess = true;
            cov_3je0ixb3g.s[71]++;
            target.node.onclick = function (element) {
              cov_3je0ixb3g.f[5]++;
              cov_3je0ixb3g.s[72]++;

              $scope.goToChildren({ id: target.node.attributes.code.value, id_: target.node.attributes.id_.value, level: target.node.attributes.level.value });
            };
            cov_3je0ixb3g.s[73]++;
            $scope.isProcess = false;
          },

          height: '100%',
          width: '100%',
          treeColumnIndex: 0,

          allowResizing: true,
          gridLines: 'Both',
          toolbar: [{ text: '<i class="fa fa-angle-up fa-2x"></i>', id: 'up_toolbar' }, 'ExpandAll', 'CollapseAll', 'ExcelExport'],
          toolbarClick: function toolbarClick(args) {
            cov_3je0ixb3g.s[74]++;

            if (args.item.id === 'up_toolbar') {
              cov_3je0ixb3g.b[15][0]++;
              cov_3je0ixb3g.s[75]++;

              $scope.goToParent();
            } else {
              cov_3je0ixb3g.b[15][1]++;
            }
            cov_3je0ixb3g.s[76]++;
            if (args.item.id === $scope.ID_COMPONENT + '_gridcontrol_pdfexport') {
              cov_3je0ixb3g.b[16][0]++;
              cov_3je0ixb3g.s[77]++;

              $scope.export.pdf();
            } else {
              cov_3je0ixb3g.b[16][1]++;
            }
            cov_3je0ixb3g.s[78]++;
            if (args.item.id === $scope.ID_COMPONENT + '_gridcontrol_excelexport') {
              cov_3je0ixb3g.b[17][0]++;
              cov_3je0ixb3g.s[79]++;

              $scope.export.excel();
            } else {
              cov_3je0ixb3g.b[17][1]++;
            }
            cov_3je0ixb3g.s[80]++;
            if (args.item.id === $scope.ID_COMPONENT + '_gridcontrol_csvexport') {
              cov_3je0ixb3g.b[18][0]++;
              cov_3je0ixb3g.s[81]++;

              $scope.treeGridObj.csvExport();
            } else {
              cov_3je0ixb3g.b[18][1]++;
            }
          },

          columns: columns
        });

        cov_3je0ixb3g.s[82]++;
        if (angular.isArray(dataSource)) {
          cov_3je0ixb3g.b[19][0]++;
          cov_3je0ixb3g.s[83]++;

          params.childMapping = 'subData';
        } else {
          cov_3je0ixb3g.b[19][1]++;
          cov_3je0ixb3g.s[84]++;

          params.hasChildMapping = 'isParent';
          cov_3je0ixb3g.s[85]++;
          params.idMapping = 'ID';
          cov_3je0ixb3g.s[86]++;
          params.parentIdMapping = 'ID_P';
        }

        cov_3je0ixb3g.s[87]++;
        $timeout(function () {
          cov_3je0ixb3g.f[6]++;
          cov_3je0ixb3g.s[88]++;

          $scope.treeGridObj = new ej.treegrid.TreeGrid(params);
          cov_3je0ixb3g.s[89]++;
          $scope.treeGridObj.appendTo('#' + $scope.ID_COMPONENT);
        }, 150);
      };

      cov_3je0ixb3g.s[90]++;
      $scope.processColumns = function (item) {
        cov_3je0ixb3g.f[7]++;

        var p = (cov_3je0ixb3g.s[91]++, $scope._processColumns(item));

        cov_3je0ixb3g.s[92]++;
        $CRUDService.getAll(p.path, p.params, function (data) {
          cov_3je0ixb3g.f[8]++;
          cov_3je0ixb3g.s[93]++;

          $scope.isProcess = false;
          var _ = (cov_3je0ixb3g.s[94]++, (angular.isArray(data) ? (cov_3je0ixb3g.b[20][0]++, data) : (cov_3je0ixb3g.b[20][1]++, [])).sort(p.order).map(p.mapping));
          cov_3je0ixb3g.s[95]++;
          if (_.length == 0) {
            cov_3je0ixb3g.b[21][0]++;
            cov_3je0ixb3g.s[96]++;

            return;
          } else {
            cov_3je0ixb3g.b[21][1]++;
          }
          cov_3je0ixb3g.s[97]++;
          if ((cov_3je0ixb3g.b[23][0]++, !item) && (cov_3je0ixb3g.b[23][1]++, $scope.analyse.AXE2 == 2)) {
            cov_3je0ixb3g.b[22][0]++;
            cov_3je0ixb3g.s[98]++;

            _ = [{ id: '0_0_0', id_: '0_0_0', level: 0, label: 'Global', code: '0_0_0' }];
          } else {
            cov_3je0ixb3g.b[22][1]++;
          }
          cov_3je0ixb3g.s[99]++;
          if ($scope.treeGridObj) {
            cov_3je0ixb3g.b[24][0]++;
            cov_3je0ixb3g.s[100]++;

            $scope.treeGridObj.destroy();
          } else {
            cov_3je0ixb3g.b[24][1]++;
          }

          var requestParam = (cov_3je0ixb3g.s[101]++, {
            ida: $scope.analyse.id,
            get: 'table_new',
            id: 0,
            a1: '',
            a2: item ? (cov_3je0ixb3g.b[25][0]++, item.id) : (cov_3je0ixb3g.b[25][1]++, ''),
            la1: 0,
            la2: item ? (cov_3je0ixb3g.b[26][0]++, (cov_3je0ixb3g.b[27][0]++, item.level) || (cov_3je0ixb3g.b[27][1]++, 0)) : (cov_3je0ixb3g.b[26][1]++, 0),
            p_bksb_: $scope.analyse.ID_PROJET
          });

          cov_3je0ixb3g.s[102]++;
          $CRUDService.getAll(PATH, requestParam, function (data) {
            cov_3je0ixb3g.f[9]++;

            var keys = (cov_3je0ixb3g.s[103]++, {});
            var displayKeys = (cov_3je0ixb3g.s[104]++, {});
            cov_3je0ixb3g.s[105]++;
            for (var _iterator3 = _, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
              var _ref3;

              if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
              } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
              }

              var item_ = _ref3;
              cov_3je0ixb3g.s[106]++;

              displayKeys[item_.id] = false;
            }

            cov_3je0ixb3g.s[107]++;
            for (var _iterator4 = data.result, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
              var _ref4;

              if (_isArray4) {
                if (_i4 >= _iterator4.length) break;
                _ref4 = _iterator4[_i4++];
              } else {
                _i4 = _iterator4.next();
                if (_i4.done) break;
                _ref4 = _i4.value;
              }

              var _item = _ref4;

              var _keys = (cov_3je0ixb3g.s[108]++, Object.keys(_item).map(function (value) {
                cov_3je0ixb3g.f[10]++;
                cov_3je0ixb3g.s[109]++;

                if ($scope.analyse.AXE2 == 2) {
                  cov_3je0ixb3g.b[28][0]++;

                  var t = (cov_3je0ixb3g.s[110]++, value.split('_'));
                  cov_3je0ixb3g.s[111]++;
                  if (t.length === 4) {
                    cov_3je0ixb3g.b[29][0]++;
                    cov_3je0ixb3g.s[112]++;

                    t.pop();
                    cov_3je0ixb3g.s[113]++;
                    return [t.join('_'), 0];
                  } else {
                    cov_3je0ixb3g.b[29][1]++;
                  }
                  cov_3je0ixb3g.s[114]++;
                  return [];
                } else {
                  cov_3je0ixb3g.b[28][1]++;
                }
                cov_3je0ixb3g.s[115]++;
                return value.split('_');
              }).filter(function (value) {
                cov_3je0ixb3g.f[11]++;
                cov_3je0ixb3g.s[116]++;

                if (value.length != 2) {
                  cov_3je0ixb3g.b[30][0]++;
                  cov_3je0ixb3g.s[117]++;

                  return false;
                } else {
                  cov_3je0ixb3g.b[30][1]++;
                }
                cov_3je0ixb3g.s[118]++;
                return !displayKeys[value[0]];
              }));
              cov_3je0ixb3g.s[119]++;
              for (var _iterator6 = _keys, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
                var _ref6;

                if (_isArray6) {
                  if (_i6 >= _iterator6.length) break;
                  _ref6 = _iterator6[_i6++];
                } else {
                  _i6 = _iterator6.next();
                  if (_i6.done) break;
                  _ref6 = _i6.value;
                }

                var key = _ref6;
                cov_3je0ixb3g.s[120]++;

                displayKeys[key[0]] = true;
              }
            }

            var columns = (cov_3je0ixb3g.s[121]++, [{ field: 'L', headerText: '', autoFit: true }]);
            cov_3je0ixb3g.s[122]++;
            for (var _iterator5 = _, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
              var _ref5;

              if (_isArray5) {
                if (_i5 >= _iterator5.length) break;
                _ref5 = _iterator5[_i5++];
              } else {
                _i5 = _iterator5.next();
                if (_i5.done) break;
                _ref5 = _i5.value;
              }

              var _item_ = _ref5;
              cov_3je0ixb3g.s[123]++;

              if (!displayKeys[(cov_3je0ixb3g.b[32][0]++, _item_.CODE_LC) || (cov_3je0ixb3g.b[32][1]++, _item_.CODE_CLC) || (cov_3je0ixb3g.b[32][2]++, _item_.id)]) {
                cov_3je0ixb3g.b[31][0]++;
                cov_3je0ixb3g.s[124]++;

                continue;
              } else {
                cov_3je0ixb3g.b[31][1]++;
              }
              var myCol = (cov_3je0ixb3g.s[125]++, {
                headerText: _item_.label,
                textAlign: 'center',
                columns: [],
                minWidth: $scope.displayColumns.length * 150,
                customAttributes: { style: { 'font-weight': 'bold' }, id_: _item_.id_, level: item ? (cov_3je0ixb3g.b[33][0]++, $scope.analyse.AXE2 == 2 ? (cov_3je0ixb3g.b[34][0]++, item.level) : (cov_3je0ixb3g.b[34][1]++, parseInt((cov_3je0ixb3g.b[35][0]++, item.level) || (cov_3je0ixb3g.b[35][1]++, 0), 10) + 1)) : (cov_3je0ixb3g.b[33][1]++, 1), code: _item_.id }
              });
              cov_3je0ixb3g.s[126]++;
              for (var _iterator7 = $scope.displayColumns, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
                var _ref7;

                if (_isArray7) {
                  if (_i7 >= _iterator7.length) break;
                  _ref7 = _iterator7[_i7++];
                } else {
                  _i7 = _iterator7.next();
                  if (_i7.done) break;
                  _ref7 = _i7.value;
                }

                var col = _ref7;
                cov_3je0ixb3g.s[127]++;

                myCol.columns.push({
                  field: _item_.id + '_' + col.id,
                  headerText: col.label,
                  headerTemplate: '<div style="font-weight: bold">' + col.label + '</div>',
                  headerTextAlign: 'center',
                  width: col.width,
                  autoFit: true,
                  format: col.format,
                  textAlign: 'right'
                });
              }
              cov_3je0ixb3g.s[128]++;
              columns.push(myCol);
            }
            cov_3je0ixb3g.s[129]++;
            $scope.drawTable(columns, data.result);
          });
        });
      };

      cov_3je0ixb3g.s[130]++;
      $scope._processColumns = function (item) {
        cov_3je0ixb3g.f[12]++;

        var PATH = (cov_3je0ixb3g.s[131]++, '');
        var params = (cov_3je0ixb3g.s[132]++, { get: 'all', p_bksb_: $scope.analyse.ID_PROJET });cov_3je0ixb3g.s[133]++;

        var mapping = function mapping() {
          cov_3je0ixb3g.f[13]++;
          cov_3je0ixb3g.s[134]++;

          return '';
        };
        cov_3je0ixb3g.s[135]++;
        var order = function order(itemA, itemB) {
          cov_3je0ixb3g.f[14]++;
          cov_3je0ixb3g.s[136]++;

          return true;
        };
        cov_3je0ixb3g.s[137]++;
        switch (parseInt($scope.analyse.AXE2, 10)) {
          case 1:
            cov_3je0ixb3g.b[36][0]++;
            cov_3je0ixb3g.s[138]++;

            PATH = 'CadreLogique';
            cov_3je0ixb3g.s[139]++;
            params.id = item ? (cov_3je0ixb3g.b[37][0]++, item.id_) : (cov_3je0ixb3g.b[37][1]++, 0);
            var _ = (cov_3je0ixb3g.s[140]++, item ? (cov_3je0ixb3g.b[38][0]++, item.id.length) : (cov_3je0ixb3g.b[38][1]++, 0));
            cov_3je0ixb3g.s[141]++;
            mapping = function mapping(value) {
              cov_3je0ixb3g.f[15]++;
              cov_3je0ixb3g.s[142]++;

              return { label: value.CODE_CLC.substr(_) + ': ' + value.LIBELLE_C_CL, id_: value.id, id: value.CODE_CLC };
            };
            cov_3je0ixb3g.s[143]++;
            order = function order(itemA, itemB) {
              cov_3je0ixb3g.f[16]++;
              cov_3je0ixb3g.s[144]++;

              return itemA.CODE_CLC > itemB.CODE_CLC ? (cov_3je0ixb3g.b[39][0]++, 1) : (cov_3je0ixb3g.b[39][1]++, -1);
            };
            cov_3je0ixb3g.s[145]++;
            break;
          case 2:
            cov_3je0ixb3g.b[36][1]++;
            cov_3je0ixb3g.s[146]++;

            PATH = 'Periode';
            cov_3je0ixb3g.s[147]++;
            if ($scope.listItem.length === 1) {
              cov_3je0ixb3g.b[40][0]++;
              cov_3je0ixb3g.s[148]++;

              mapping = function mapping(value) {
                cov_3je0ixb3g.f[17]++;
                cov_3je0ixb3g.s[149]++;

                return { label: value.ANNEE_PERIOD, id: value.ANNEE_PERIOD + '_1_1', id_: value.id, level: value.DECOUPAGE_PERIOD };
              };
              cov_3je0ixb3g.s[150]++;
              order = function order(itemA, itemB) {
                cov_3je0ixb3g.f[18]++;
                cov_3je0ixb3g.s[151]++;

                return itemA.ANNEE_PERIOD > itemB.ANNEE_PERIOD ? (cov_3je0ixb3g.b[41][0]++, 1) : (cov_3je0ixb3g.b[41][1]++, -1);
              };
            } else {
              cov_3je0ixb3g.b[40][1]++;
            }

            cov_3je0ixb3g.s[152]++;
            if ($scope.listItem.length >= 2) {
              cov_3je0ixb3g.b[42][0]++;
              cov_3je0ixb3g.s[153]++;

              params.get = 'allsousperiod';
              cov_3je0ixb3g.s[154]++;
              params.id = item.id_;
              cov_3je0ixb3g.s[155]++;
              mapping = function mapping(value, index, values) {
                cov_3je0ixb3g.f[19]++;

                var id = (cov_3je0ixb3g.s[156]++, item.id.substr(0, 5) + value.NIVEAU_DECOUP + '_' + values.length);
                cov_3je0ixb3g.s[157]++;
                return { label: $filter('date')(value.DATE_FIN_DECOUP, 'mediumDate'), id: id, id_: id };
              };
              cov_3je0ixb3g.s[158]++;
              order = function order(itemA, itemB) {
                cov_3je0ixb3g.f[20]++;
                cov_3je0ixb3g.s[159]++;

                return itemA.DATE_DEB_DECOUP > itemB.DATE_DEB_DECOUP ? (cov_3je0ixb3g.b[43][0]++, 1) : (cov_3je0ixb3g.b[43][1]++, -1);
              };
            } else {
              cov_3je0ixb3g.b[42][1]++;
            }
            cov_3je0ixb3g.s[160]++;
            break;
          case 3:
            cov_3je0ixb3g.b[36][2]++;
            cov_3je0ixb3g.s[161]++;

            PATH = 'Localites';
            cov_3je0ixb3g.s[162]++;
            params.id = item ? (cov_3je0ixb3g.b[44][0]++, item.id_) : (cov_3je0ixb3g.b[44][1]++, 0);
            cov_3je0ixb3g.s[163]++;
            mapping = function mapping(value) {
              cov_3je0ixb3g.f[21]++;
              cov_3je0ixb3g.s[164]++;

              return { label: value.CODE_LC + ': ' + value.DESCRIPTION_L, id_: value.id, id: value.CODE_LC };
            };
            cov_3je0ixb3g.s[165]++;
            order = function order(itemA, itemB) {
              cov_3je0ixb3g.f[22]++;
              cov_3je0ixb3g.s[166]++;

              return itemA.CODE_LC > itemB.CODE_LC ? (cov_3je0ixb3g.b[45][0]++, 1) : (cov_3je0ixb3g.b[45][1]++, -1);
            };
            cov_3je0ixb3g.s[167]++;
            break;
          case 4:
            cov_3je0ixb3g.b[36][3]++;
            cov_3je0ixb3g.s[168]++;

            PATH = 'Financement';
            cov_3je0ixb3g.s[169]++;
            mapping = function mapping(value) {
              cov_3je0ixb3g.f[23]++;
              cov_3je0ixb3g.s[170]++;

              return { label: value.LIBELLE_FIN, id: value.id };
            };
            cov_3je0ixb3g.s[171]++;
            order = function order(itemA, itemB) {
              cov_3je0ixb3g.f[24]++;
              cov_3je0ixb3g.s[172]++;

              return itemA.LIBELLE_FIN > itemB.LIBELLE_FIN ? (cov_3je0ixb3g.b[46][0]++, 1) : (cov_3je0ixb3g.b[46][1]++, -1);
            };
            cov_3je0ixb3g.s[173]++;
            break;
          case 5:
            cov_3je0ixb3g.b[36][4]++;
            cov_3je0ixb3g.s[174]++;

            PATH = 'CategoriesBudget';
            cov_3je0ixb3g.s[175]++;
            mapping = function mapping(value) {
              cov_3je0ixb3g.f[25]++;
              cov_3je0ixb3g.s[176]++;

              return { label: value.CODE_CAT + ' - ' + value.LABEL_CAT, id: value.id };
            };
            cov_3je0ixb3g.s[177]++;
            order = function order(itemA, itemB) {
              cov_3je0ixb3g.f[26]++;
              cov_3je0ixb3g.s[178]++;

              return itemA.LABEL_CAT > itemB.LABEL_CAT ? (cov_3je0ixb3g.b[47][0]++, 1) : (cov_3je0ixb3g.b[47][1]++, -1);
            };
            cov_3je0ixb3g.s[179]++;
            break;
          default:
            cov_3je0ixb3g.b[36][5]++;

        }

        cov_3je0ixb3g.s[180]++;
        return { path: PATH, params: params, mapping: mapping, order: order };
      };

      cov_3je0ixb3g.s[181]++;
      $scope.process.open($scope.analyse);
    }
  };
});